export default __webpack_public_path__ + "static/media/juego rio 2-28.fa675001.png";